import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import { Pill, type PillProps } from 'src/component/ds/ui/pill';
import { cn } from 'src/component/ds/utils';

export interface FilterChipProps extends Omit<PillProps, 'value' | 'variant' | 'trailingIcon'> {
  count?: number;
  applied: boolean;
}

export const FilterChip = React.forwardRef<HTMLButtonElement, FilterChipProps>(
  ({ count, applied, disabled, className, ...props }, ref) => {
    const TrailingIcon = applied ? CloseIcon : AddIcon;
    return (
      <Pill
        ref={ref}
        variant={applied ? 'secondary' : 'outline'}
        value={count ?? '–'}
        aria-pressed={applied}
        disabled={disabled || (!applied && count === 0)}
        className={cn(!applied && 'ds-shadow-xs', className)}
        trailingIcon={<TrailingIcon fontSize='inherit' aria-hidden='true' />}
        {...props}
      />
    );
  }
);
FilterChip.displayName = 'FilterChip';
